export const progressBarsHeight = "4px";

export const MAX_RETRIES = 3;
export const MILESTONE_RETRY_TIME = 10;

export const SHIPMENT_MODE = {
  AIR: "Air",
  GROUND: "Ground",
};

export const API_STATUS = {
  InProgress: "in-progress",
  Success: "success",
  Failed: "failed",
};
export const EmailNotSentMoveToNextMilestoneSesciption =
  "Email update for this milestone has not been sent to the customer, this might be due to technical/network issues. Please contact your Sciens Logistics AOG operations manager immediately before you proceed to the next milestone and continue with your AOG.";

export const ONBOARDING_STATUS = Object.freeze({
  EMAIL_CAPTURED: "EMAIL_CAPTURED",
  IN_ONBOARDING_1: "IN_ONBOARDING_1",
  IN_ONBOARDING_2: "IN_ONBOARDING_2",
  IN_ONBOARDING_3: "IN_ONBOARDING_3",
  IN_ONBOARDING_4: "IN_ONBOARDING_4",
  IN_REVIEW: "IN_REVIEW",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  SYSTEM_REJECTED: "SYSTEM_REJECTED",
  PARTIAL_REJECTED: "PARTIAL_REJECTED",
});
